import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/img/logo-text-dark.png'
import _imports_1 from '@/assets/img/logo-text.png'


const _hoisted_1 = {
  key: 0,
  class: "header-logo_text",
  src: _imports_0,
  alt: ""
}
const _hoisted_2 = {
  key: 1,
  class: "header-logo_text",
  src: _imports_1,
  alt: ""
}

import useOpenApp from '@/hooks/useOpenApp'
  import { useDark } from '@vueuse/core'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'header',
  props: {
    buttonText: { default: '打开App' },
    buttonClick: {},
    size: { default: 'default' },
    forceLight: { type: Boolean, default: false }
  },
  setup(__props: any) {

  const props = __props

  const isDark = useDark({
    selector: 'html',
    attribute: 'data-theme',
    valueDark: 'dark',
    valueLight: 'light',
  })

  const { openApp } = useOpenApp()

  const handleClick = () => {
    if (props.buttonClick) {
      props.buttonClick()
      return
    }
    openApp()
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["header", {
      'header-large': props.size === 'large',
      'header-light': props.forceLight,
    }])
  }, [
    (_unref(isDark) && !props.forceLight)
      ? (_openBlock(), _createElementBlock("img", _hoisted_1))
      : (_openBlock(), _createElementBlock("img", _hoisted_2)),
    _createElementVNode("button", {
      class: "header-btn",
      onClick: handleClick
    }, _toDisplayString(_ctx.$t(props.buttonText)), 1)
  ], 2))
}
}

})